import React from "react";
import ComingSoon from "../components/ComingSoon";

const NBADraft = () => {
  return <ComingSoon pageName="NBA/Professional Draft Model" />;
};

export default NBADraft;
